module.exports = __webpack_public_path__ + "static/img/7.f232dac.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/csfish/7.png
// module id = WJC8
// module chunks = 0